import luhn from "fast-luhn";
import { getCodes, getData } from "country-list";

const EU_COUNTRIES_CODES = [
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "EL",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
  "XI"
];

const REGEX_ONLY_DIGITS_IT = /^[0-9]{11}$/;

export function validateEUVatNumber(vatNumberWithCountryCode: string): boolean {
  const countryCode = vatNumberWithCountryCode.substr(0, 2)?.toUpperCase();
  const vatNumber = vatNumberWithCountryCode.substr(2);

  if (!countryCode || !vatNumber) {
    return false;
  }

  if (EU_COUNTRIES_CODES.indexOf(countryCode) === -1) {
    return false;
  }

  switch (countryCode) {
    case "IT": {
      return REGEX_ONLY_DIGITS_IT.test(vatNumber) && luhn(vatNumber);
    }
    default: {
      return true;
    }
  }
}

const COUNTRY_CODES = getCodes().filter((x) => x !== "IT");

export function validateGlobalVatNumber(vatNumberWithCountryCode: string): {
  valid: boolean;
  countryCode?: string;
} {
  const countryCode = vatNumberWithCountryCode.substr(0, 2)?.toUpperCase();
  const vatNumber = vatNumberWithCountryCode.substr(2);

  if (!countryCode || !vatNumber) {
    return {
      valid: false
    };
  }

  return { valid: !!COUNTRY_CODES.includes(countryCode), countryCode };
}

export function getVatNumberCountriesWithoutItaly(): Array<{
  code: string;
  name: string;
}> {
  return getData()
    .filter((x) => x.code !== "IT")
    .map((x) => ({
      code: x.code,
      name: x.name
    }));
}

export function validateTaxRegistrationNumber(
  taxRegistrationNumber: string
): boolean {
  return /^\d{15}$/.test(taxRegistrationNumber);
}
